<p class="container-fluid h3 font-weight-bold q-c-main">
  {{'graphApprenantByModules' |trad}}</p>
<div *ngIf="AvancementChapitreEL?.ListAvancement?.length > 0" class="w-100 graph" #graphtest></div>
<h1 *ngIf="AvancementChapitreEL?.ListAvancement?.length == 0" class="text-center q-c-light-main q-font"><i class="fas fa-chart-bar"></i> Pas de données à afficher</h1>
